import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/blog/BlogPageClient.tsx");
